import { z } from 'zod';
import { UserDetailsModel } from '../types/user.js';

export const SessionTypeEnum = z.enum(['anonymous', 'user']);
export type SessionTypeEnum = z.infer<typeof SessionTypeEnum>;

export const BaseSession = z.object({
  id: z.string(),
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  createdOn: z.coerce.date(),
  lastUpdatedOn: z.coerce.date().nullable(),
  jwtFingerprint: z.string().nullable(),
  expiresOn: z.coerce.date(),
  version: z.literal('1'),
});

export const anonymousSessionSchema = BaseSession.extend({
  type: z.literal(SessionTypeEnum.enum.anonymous),
});
export type AnonymousSession = z.infer<typeof anonymousSessionSchema>;

export const User = z.object({
  id: z.number(),
  identifier: z.string(),
  username: z.string(),
  email: z.email().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
});
export type User = z.infer<typeof User>;

export const Group = z.object({
  id: z.number(),
});
export type Group = z.infer<typeof Group>;

export const userSessionSchema = BaseSession.extend({
  type: z.literal(SessionTypeEnum.enum.user),
  remember: z.boolean(),
  user: UserDetailsModel,
});
export type UserSession = z.infer<typeof userSessionSchema>;

export const sessionSchema = z.discriminatedUnion('type', [
  anonymousSessionSchema,
  userSessionSchema,
]);
export type Session = z.infer<typeof sessionSchema>;